import React, { Component } from 'react';

import Wrapper from '../../../hoc/Wrapper/Wrapper';

import CloseIcon from '../../../assets/icons/icon-close-black.png'

import Button from '../Button/Button';
import ShowMiniLoader from '../../../hoc/ShowMiniLoader/ShowMiniLoader';

import classes from './NotificationToast.module.css';
import { IsStringEmpty, GetFromLocalStorage, Log, cleanHTML } from '../../../utilities/CommonMethods';
import { Link } from 'react-router-dom';
import RouteEndPoints from '../../../utilities/RouteEndPoints';

class NotificationToast extends Component {

    state = {
        hideToast: true,
        showErrorText: false,
        showMiniLoader: false
    }

    closeToastClicked = () => {
        this.setState({ hideToast: true });
        setTimeout(() => {
            this.props.closeToastClicked(this.props.data, 'Button Clicked');
        }, 500);
    }


    componentDidMount() {

        setTimeout(() => {
            this.setState({ hideToast: false });
        }, 1000);

        if (!IsStringEmpty(this.props.duration)) {
            setTimeout(() => {
                this.closeToastClicked();
            }, this.props.duration);
        }

    }

    render() {
        let stylesClasses = [classes.NotificationToast];

        !IsStringEmpty(this.props.visible) && this.props.visible && !this.state.hideToast ? stylesClasses.push(classes.Show) : stylesClasses.push(classes.Hide);

        return (
            <Wrapper>
                <div className={stylesClasses.join(' ')}>
                    <img className={classes.CloseIcon} src={CloseIcon} onClick={this.state.showMiniLoader ? null : () => this.props.closeToastClicked(this.props.data, 'Closed Toast')} title={!this.state.showMiniLoader ? null : 'Please wait, while loading completes.'} />

                    {/* <img className={classes.ToastImg} style={{ width: propsWidth, height: propsHeight }} src={this.props.data.notificationIcon} /> */}
                    <div>
                        <p className={classes.Tag}>{this.props.data.tag}</p>
                        <p className={classes.ToastTitle}>{this.props.data.label}</p>
                        <p className={classes.ToastMessage} dangerouslySetInnerHTML={{ __html: cleanHTML(this.props.data.message) }}></p>
                        <div>
                            {!IsStringEmpty(this.props.data.url)
                                ? this.props.data.url.indexOf('https://') > -1 || this.props.data.url.indexOf('http://') > -1 || this.props.data.url.indexOf('www.') > -1
                                    ? <a href={this.props.data.url} target="_blank" className={classes.RemoveTextDecoration} onClick={() => this.closeToastClicked()}>
                                        <Button
                                            styleclass={["NonMobileOnly GoToCourseButton", this.props.dailyZensClaimed ? "Disabled" : ''].join(' ')}
                                            label={!IsStringEmpty(this.props.data.cta) ? this.props.data.cta : 'OKAY'}
                                            padding="1em 2em"
                                            fontSize="0.8em"
                                            margin="0.5em 0em"
                                            clicked={null}
                                        />
                                        <Button
                                            styleclass={["MobileOnly GoToCourseButton", this.props.dailyZensClaimed ? "Disabled" : ''].join(' ')}
                                            label={!IsStringEmpty(this.props.data.cta) ? this.props.data.cta : 'OKAY'}
                                            padding="auto"
                                            margin="0px 0px 0px 0px"
                                            fontSize="0.625em"
                                            clicked={null}
                                        />
                                    </a>
                                    : <Link to={RouteEndPoints.HOME_PAGE + this.props.data.url} className={classes.RemoveTextDecoration} onClick={() => this.closeToastClicked()}>
                                        <Button
                                            styleclass={["NonMobileOnly GoToCourseButton", this.props.dailyZensClaimed ? "Disabled" : ''].join(' ')}
                                            label={!IsStringEmpty(this.props.data.cta) ? this.props.data.cta : 'OKAY'}
                                            padding="1em 2em"
                                            fontSize="0.8em"
                                            margin="0.5em 0em"
                                            clicked={null}
                                        />
                                        <Button
                                            styleclass={["MobileOnly GoToCourseButton", this.props.dailyZensClaimed ? "Disabled" : ''].join(' ')}
                                            label={!IsStringEmpty(this.props.data.cta) ? this.props.data.cta : 'OKAY'}
                                            padding="auto"
                                            margin="0px 0px 0px 0px"
                                            fontSize="0.625em"
                                            clicked={null}
                                        />
                                    </Link>
                                : <React.Fragment>
                                    <Button
                                        styleclass={["NonMobileOnly GoToCourseButton", this.props.dailyZensClaimed ? "Disabled" : ''].join(' ')}
                                        label={!IsStringEmpty(this.props.data.cta) ? this.props.data.cta : 'OKAY'}
                                        padding="1em 2em"
                                        fontSize="0.8em"
                                        margin="0.5em 0em"
                                        clicked={this.closeToastClicked}
                                    />
                                    <Button
                                        styleclass={["MobileOnly GoToCourseButton", this.props.dailyZensClaimed ? "Disabled" : ''].join(' ')}
                                        label={!IsStringEmpty(this.props.data.cta) ? this.props.data.cta : 'OKAY'}
                                        padding="auto"
                                        margin="0px 0px 0px 0px"
                                        fontSize="0.625em"
                                        clicked={this.closeToastClicked}
                                    />
                                </React.Fragment>
                            }
                        </div>
                    </div>

                    {
                        this.props.showTimeline
                            ? <span className={[classes.TimeLine, this.props.visible && this.props.showTimeline ? classes.Animate : ''].join(' ')} ref={timeLine => this.timeLine = timeLine}></span>
                            : null
                    }

                </div>
            </Wrapper>
        );
    }
}

export default NotificationToast;